module.exports = __webpack_public_path__ + "img/男-结直肠癌h.db2d13cc.png";